/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTempChevronsDropdownSmall: {
  name: 'temp-chevrons-dropdown-small';
  data: string;
} = {
  name: 'temp-chevrons-dropdown-small',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M11 6H5l3 4 3-4Z" fill="currentColor"/></svg>`,
};
